var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.emitsClickEvent)?_c('btn',{staticClass:"icon__button",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('span',{class:_vm.classes})]):(_vm.link)?_c('b-link',{class:_vm.classes,attrs:{"to":_vm.link}}):_c('span',{class:_vm.classes})
}
var staticRenderFns = []

export { render, staticRenderFns }